import React from "react";
import { Col, Row } from "reactstrap";

export default function ModulesSettingsIntro() {
  return (
    <>
      <Row>
        <Col md={2}></Col>
        <Col md={8}>
          <div
            style={{ height: "calc(80vh - 100px)" }}
            className={
              "d-flex flex-column justify-content-center align-items-center"
            }
          >
            <div>
              <h1 className={"p-2"}>Modules Overview</h1>
            </div>
            <div>
              <h6 className={"text-muted text-center"}>
                Welcome to the hub of modules configuration. Here, you can
                effortlessly tweak settings, adjust statuses, and make necessary
                changes to align everything perfectly with your business's needs
                and goals.{" "}

              </h6>
            </div>
          </div>
        </Col>
        <Col md={2}></Col>
      </Row>
    </>
  );
}
